import { Stack, Text } from '@mantine/core';
import { Button } from 'src/components';

interface ExpiredInviteSectionProps {
  onLoginClick: () => void;
}

export const ExpiredInviteSection = ({ onLoginClick }: ExpiredInviteSectionProps) => (
  <Stack align="center" gap="md">
    <Text c="gray.0" fz={36} fw={700}>
      Oops, this invite link is no longer valid
    </Text>
    <Text c="gray.0" ta="center" fz={24} fw={500}>
      It may have expired or already been used.
      <br />
      Please contact your administrator to request a new invite.
    </Text>

    <Button onClick={onLoginClick} size="lg">
      Already have an account? Log in
    </Button>
  </Stack>
);
